import React, { useContext, useState } from 'react'
import { Box } from '@mui/material'
import TriggerChartDetailsInput from './TriggerChartDetailsInput'
import { PatternTreeContext } from '../contexts/PatternTreeContext'

interface TriggerChartSelectorProps {
  onEdit?: (isEditing: boolean) => void
  readOnly?: boolean
}

const TriggerChartSelector = ({ readOnly = false, onEdit }: TriggerChartSelectorProps) => {
  const { pattern, handleChangePattern } = useContext(PatternTreeContext)

  const [isEditingTriggerChart, setIsEditingTriggerChart] = useState(false)

  function handleIsEditing(isEditing: boolean) {
    if (onEdit) {
      onEdit(isEditing)
    }

    setIsEditingTriggerChart(isEditing)
  }

  return (
    <Box
      width={isEditingTriggerChart ? '600px' : '210px'}
      display={'flex'}
      gap={1}
      color={'white'}
      data-tour-id={'trigger-chart-selector'}
    >
      <TriggerChartDetailsInput
        trigger={pattern.trigger}
        handleChange={(key: string, value: any) =>
          !readOnly && handleChangePattern(`trigger.${key}`, value)
        }
        onEdit={(isEditing) => handleIsEditing(isEditing)}
        readOnly={readOnly}
      />
    </Box>
  )
}

export default TriggerChartSelector
